export default __webpack_public_path__ + "static/media/new-badge.9116f07c.svg";